import { Bird, Cat, Dog, Fish, PawPrint, Rabbit } from "lucide-react";
import { mediaUrl } from "@/lib/api";

export default function PetAvatar({ pet, size = 56 }) {
  const src = mediaUrl(pet?.photo_url);
  const bg = pet?.species === "cat" ? "bg-teal/15" : "bg-marigold/20";
  const icon = { className: "text-stoneWarm", style: { width: size * 0.5, height: size * 0.5 }, strokeWidth: 1.8 };
  return (
    <div className={`rounded-full overflow-hidden flex items-center justify-center shrink-0 ${bg}`} style={{ width: size, height: size }}>
      {src ? <img src={src} alt={pet?.name || "Pet"} className="w-full h-full object-cover" /> : pet?.species === "dog" ? <Dog {...icon} /> : pet?.species === "cat" ? <Cat {...icon} /> : pet?.species === "bird" ? <Bird {...icon} /> : pet?.species === "fish" ? <Fish {...icon} /> : pet?.species === "rabbit" ? <Rabbit {...icon} /> : <PawPrint {...icon} />}
    </div>
  );
}
